import { ActionReview } from '@evidentid/tprm-portal-lib/models/entity-actions-review';

import { formatDateTime } from '@/utils/formatDateTime';

const outcomeLabels: Record<string, string> = {
    accepted: 'Accepted',
    rejected: 'Rejected',
};

export function getOutcomeLabel(action: ActionReview): string {
    const outcome = action.resolution?.outcome;
    return outcome ? outcomeLabels[outcome] || '' : '';
}

export function getResolvedBy(action: ActionReview): string {
    return action.resolution?.resolvedBy || '';
}

export function getResolvedDate(action: ActionReview): string {
    return formatDateTime(action.resolution?.resolvedAt);
}

export function isReverted(action: ActionReview): boolean {
    return Boolean(action.resolution?.revertedAt);
}

export function getRevertedLabel(action: ActionReview): string {
    return isReverted(action) ? 'Yes' : 'No';
}
